export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11264.25f2dd5d.jpg";